module.exports = __webpack_public_path__ + "img/creditcard.654b0f93.gif";